import {
  Create,
  SimpleForm,
  SelectInput,
  TextInput,
  ReferenceInput,
  required,
} from 'react-admin';

export const ChatCreate = () => (
  <Create redirect="show">
    <SimpleForm>
      <TextInput source="name" fullWidth label="Имя" />
      <SelectInput
        source="api_type"
        fullWidth
        label="Ресурс"
        choices={[
          { id: 'tg', name: 'Телеграм' },
          { id: 'custom', name: 'Кастомный' },
        ]}
      />

      <TextInput source="api_token" fullWidth label="Токен" />
      <TextInput
        label="Стартовое сообщение"
        variant="outlined"
        multiline
        minRows={4}
        maxRows={6}
        source="start_message"
        fullWidth
        placeholder="Введите стартовое сообщение"
        validate={[required('Обязательно для заполнения')]}
      />
      <ReferenceInput source="model_id" reference="models" label="Модель">
        <SelectInput source="id" label="Модель" optionText="name" />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);
